import Vue from 'vue'
import App from './App'
import router from './router'
// import { store } from './store'

Vue.config.productionTip = false


// ##########################################
// ################ COMPONENTS ##############
// ##########################################
import AppHeader from './components/AppHeader.vue'
import HomeSection from './components/HomeSection.vue'
import HistorySection from './components/HistorySection.vue'
import FeaturesSection from './components/FeaturesSection.vue'
import TopTracks from './components/TopTracks.vue'
import TeamSection from './components/TeamSection.vue'
import ContactSection from './components/Contact.vue'
import ExtraSection from './components/ExtraSection.vue'
import AppFooter from './components/AppFooter.vue'
import GallerySection from './components/GallerySection.vue'

// ##########################################
// ################ COMPONENTS ##############
// ##########################################
Vue.component('app-header', AppHeader)
Vue.component('home-section', HomeSection)
Vue.component('history-section', HistorySection)
Vue.component('features-section', FeaturesSection)
Vue.component('top-tracks', TopTracks)
Vue.component('team-section', TeamSection)
Vue.component('contact-section', ContactSection)
Vue.component('extra-section', ExtraSection)
Vue.component('app-footer', AppFooter)
Vue.component('gallery-section', GallerySection)

// ##########################################
// ################ PLUGINS #################
// ##########################################

// BootstrapVue
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// VeeValidate
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

// VueSweetalert2
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
  duration: 1000,
  easing: "ease-in",
  offset: 0,
})

// Swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAwesomeSwiper, /* { default global options } */)

// require styles
import 'swiper/dist/css/swiper.css'

// AoS
import 'aos/dist/aos.css'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // store,
  components: {App},
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js